@if (mostrarModal) {
<div class="modal-overlay">
  <div class="modal-content">
    <h2 class="title-h2">¿Estás seguro que deseas cerrar sesión?</h2>
    <div class="modal-actions">
      <button class="button-main" (click)="onConfirm()">Aceptar</button>
      <button class="button-secundary" (click)="onCancel()">Cancelar</button>
    </div>
  </div>
</div>
}
